import { PARTNERSCORE_CUBE_NAME } from '@/api/hcp';
import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { FilterConfigDynamic } from '@/types/filter';

const DIMENSION = `${PARTNERSCORE_CUBE_NAME}.survey_title`;

const partnerScoreSurveyTitleFilter: FilterConfigDynamic = {
  label: 'main.hcpOverview.partnerScore.filter.surveyTitle',
  placeholder: 'main.hcpOverview.partnerScore.filter.surveyTitlePlaceHolder',
  type: 'multiselect',
  defaultValue: [],
  clearable: true,
  searchable: true,
  sourceCube: PARTNERSCORE_CUBE_NAME,
  getOptionsQuery: () => ({
    dimensions: [DIMENSION],
    filters: [{ member: DIMENSION, operator: 'set' }],
    limit: 10000,
  }),
  mapResult: mapDimensionToOption(DIMENSION),
  applyFilter: value => {
    const v = value as string[];
    if (!v?.length) return undefined;
    return { member: DIMENSION, operator: 'equals', values: [...v] };
  },
};

export default partnerScoreSurveyTitleFilter;
